module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Sopelana-382fb14d138a6d3a38f3489f49ade934.jpg";